import { faPlusCircle, faThumbsUp, faThumbsDown } from '@fortawesome/pro-light-svg-icons';
import React, { ForwardedRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../button/Button';
import { useSliderTooltip } from './hooks/useSliderTooltip';
import { SlideContent } from './types';

interface SliderTooltipProps {
  slideContent: SlideContent;
  handleTileTooltip: (e: React.MouseEvent) => void;
  closeTooltip: () => void;
}

export const SliderTooltip = React.forwardRef<HTMLDivElement, SliderTooltipProps>(
  function SliderTooltip(
    { slideContent, handleTileTooltip, closeTooltip },
    ref: ForwardedRef<HTMLDivElement>
  ) {
    const { t } = useTranslation();

    const { favourite, tooltipRef, handleTooltipClick } = useSliderTooltip(
      slideContent,
      closeTooltip,
      handleTileTooltip
    );

    useImperativeHandle(ref, () => tooltipRef.current as HTMLDivElement);

    return (
      <div className="slider-tooltip arrow" role="dialog" aria-modal="true" ref={tooltipRef}>
        {favourite ? (
          <Button
            className="transparent-button tooltip-row"
            onClick={(e) => handleTooltipClick(e, 'fave')}
            icon={{ faIconDefinition: faPlusCircle }}
            ariaLabel={t('FY002')}
            variant="ghost"
          >
            {t('FY002')}
          </Button>
        ) : (
          <Button
            className="transparent-button tooltip-row"
            onClick={(e) => handleTooltipClick(e, 'fave')}
            icon={{ faIconDefinition: faPlusCircle }}
            ariaLabel={t('FY001')}
            variant="ghost"
          >
            {t('FY001')}
          </Button>
        )}
        {!(slideContent.category === 'service' || slideContent.chid.startsWith('TA')) && (
          <>
            <Button
              className="transparent-button tooltip-row"
              onClick={(e) => handleTooltipClick(e, 'like')}
              icon={{ faIconDefinition: faThumbsUp }}
              ariaLabel={t('FY003')}
              variant="ghost"
            >
              {t('FY003')}
            </Button>
            <Button
              className="transparent-button tooltip-row"
              onClick={(e) => handleTooltipClick(e, 'dislike')}
              icon={{ faIconDefinition: faThumbsDown }}
              ariaLabel={t('FY004')}
              variant="ghost"
            >
              {t('FY004')}
            </Button>
          </>
        )}
      </div>
    );
  }
);
